<template>
  <div class="container-confirm-dia">
    <van-dialog v-model="showDia" :showConfirmButton="false" closeOnClickOverlay="true" @close="close">
      <div class="dialog">
        <div class="tit" v-if="title">{{ title }}</div>
        <div class="con" v-if="content" v-html="content"></div>
        <div class="footer-btn">
          <div class="btn btn-left" @click="handleLeftBtn">{{ leftBtnText }}</div>
          <div class="btn" @click="handleRightBtn">{{ rightBtnText }}</div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  props: {
    showDia: {
      default: false
    },
    title: {},
    content: {},
    leftBtnText: {},
    rightBtnText: {}
  },
  data() {
    return {}
  },
  methods: {
    close() {
      this.$parent.closeAutoDia && this.$parent.closeAutoDia()
    },
    handleLeftBtn() {
      this.$emit('leftBtn')
    },
    handleRightBtn() {
      this.$emit('rightBtn')
    }
  }
}
</script>
<style lang="scss" scoped>
.container-confirm-dia {
  .dialog {
    width: 100%;
    padding: 30px 20px;
  }
  .tit {
    width: 100%;
    font-size: 16px;
    font-family: Inter-Regular;
    font-weight: 600;
    color: #333333;
    line-height: 26px;
    text-align: center;
  }
  .con {
    width: 100%;
    margin: 20px 0 20px 0;
    font-size: 16px;
    font-family: Inter-Regular;
    font-weight: 500;
    color: #333333;
    line-height: 26px;
    text-align: left;
    overflow: hidden;
    white-space: pre-wrap;
    font-style: normal;
  }
  .footer-btn {
    display: flex;
    justify-content: space-around;
    .btn {
      width: 120px;
      height: 40px;
      margin: 0 auto;
      line-height: 40px;
      text-align: center;
      background: #a338fc;
      border-radius: 20px;
      font-size: 16px;
      font-family: Inter-Regular;
      font-weight: 600;
      color: #ffffff;
      border: 1px solid #a338fc;
    }
    .btn-left {
      background-color: #fff;
      color: #a338fc;
      border: 1px solid #a338fc;
    }
  }
}
</style>
